export const aboutData = {
    title: "Welcome to Rakesh's World!",
    description1: "My name is Rakesh Ganesula. I am from Kukunoor, West Godavari, Andhra Pradesh. I am a Software Development Engineer Intern at Amazon.",
    description2: "I am a passionate individual who always thrives to work on end to end products which develop sustainable and scalable social and technical systems to create impact. Also I am a strong believer that imagination brings the change and shows a path to develop something amazing and interesting.",
    image: 2
}
